import { render, staticRenderFns } from "./ThroughputTest.vue?vue&type=template&id=547aaf19&scoped=true&"
import script from "./ThroughputTest.vue?vue&type=script&lang=js&"
export * from "./ThroughputTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547aaf19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547aaf19')) {
      api.createRecord('547aaf19', component.options)
    } else {
      api.reload('547aaf19', component.options)
    }
    module.hot.accept("./ThroughputTest.vue?vue&type=template&id=547aaf19&scoped=true&", function () {
      api.rerender('547aaf19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/ThroughputTest.vue"
export default component.exports